{
  "출제":"배정",
  "출제자":"배정자",
  "강의":"개념학습",
  "개념강의":"개념학습",
  "학원그룹교재":"CMS교재",
  "학원 공유 교재": "센터 교재",
  "학원그룹 공유 교재": "센터 간 공유 교재",
  "학원 공유 학습지": "센터 학습지",
  "학원그룹 공유 학습지": "센터 간 공유 학습지",
  "학원": "센터",
  "반응형평가": "자동시험",
  "관리자 권한": "마스터",
  "전체 학생 권한": "매니저",
  "담당 학생 권한": "강사",
  "그룹 선택": "선생님 권한"
}